import React, { useEffect, useState } from "react";
import { useAuth } from "../context/auth";
import { authenticateUser } from "../helper/authentication";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import "../assets/css/responsive.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { getUser } from "../action/authActions";
import { useDispatch } from "react-redux";
import logoImg from "../assets/images2/logo.png";
import { useSelector } from "react-redux";

function SignIn(props) {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useAuth();
  const [redirect, setRedirect] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [user, setUser] = useState(null);

  const { pathname } = useLocation();
  const location = window.location.href;
  const homePageUrl = location.endsWith(pathname)
    ? location.slice(0, -pathname.length)
    : location;

  // console.log(
  //   process.env.REACT_APP_API_URL,
  //   "live api url ********************************************************"
  // );

  useEffect(() => {
    if (user != null) {
      dispatch({ type: "SAVE_LOGGED_USER", payload: user?.data });
      login(user?.token);
      setEmail("");
      setPassword("");
      setError("");
      navigate(`/admin/dashboard/goals`);
    }
  }, [user]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email || !password) {
      setError("Please enter both email and password");
      return;
    }

    try {
      setLoading(true);
      const data = await authenticateUser(email, password);

      if (!data?.token) {
        setError("Invalid email or password. Please try again.");
        return;
      }
      setUser(data);
    } catch (error) {
      setError("Invalid email or password. Please try again.");
      console.error("Sign-In failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Box className="sign-in-main">
        <Box
          sx={{
            display: `flex`,
            justifyContent: `start`,
            alignItems: `center`,
            py: 2.2,
            borderBottom: `1px solid #E5E7EB`,
          }}
        >
          <Box component="a" href={homePageUrl} className="admin-logo">
            <img src={logoImg} alt="Everyland Logo" />
          </Box>
        </Box>
        <Box className="auth_page_main">
          <Box className="auth_form_main">
            <Box className="auth_form_inner">
              <Box className="auth-form">
                <Typography component="h1" className="heading">
                  Welcome back!
                </Typography>
                <Typography
                  variant="span"
                  component="span"
                  className="sub_heading"
                >
                  Nice to meet your! Enter your details to login.
                </Typography>
                {error && <Alert severity="error"> {error}</Alert>}
                <Box component="form" onSubmit={handleSubmit}>
                  <Box className="full_fields">
                    <Typography
                      variant="span"
                      component="span"
                      className="labels"
                    >
                      Email
                    </Typography>
                    <TextField
                      id="outlined-basic"
                      // label="Email"
                      // variant="outlined"
                      placeholder="Email address"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      inputProps={{
                        className: "admin-input",
                      }}
                    />
                  </Box>
                  <Box className="full_fields">
                    <Typography
                      variant="span"
                      component="span"
                      className="labels"
                    >
                      Password
                    </Typography>
                    <TextField
                      id="outlined-basic"
                      placeholder="Password"
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      inputProps={{
                        className: "admin-input",
                      }}
                    />
                  </Box>

                  <Box className="action">
                    <Button
                      variant="contained"
                      type="submit"
                      className=""
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress size={25} sx={{ color: "#fff" }} />
                      ) : (
                        "Sign In"
                      )}
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: `flex`,
            justifyContent: `center`,
            alignItems: `center`,
            py: 2.2,
            borderTop: `1px solid #E5E7EB`,
          }}
        >
          <Box component="a" href={homePageUrl} className="footer">
            <Typography variant="span" component="span" className="">
              © 2026 MyNetGoals. All rights reserved.
            </Typography>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
}

export default SignIn;
